<app-offers-table [livasRegionId]="regionName"
                  [personId]="personId"
                  [country]="country"
                  [sex]="sex"
                  [columns]="columnsToDisplay"
></app-offers-table>
